import React from 'react';
import { DeleteOutlined } from '@ant-design/icons';
import { AppSettingResponseModel, MobileAppSettingModel } from '@uniquegood/realworld-admin-interface/dist';
import { Space, Switch, message } from 'antd';
import Paragraph from 'antd/es/typography/Paragraph';

const isNumericString = (input: unknown): boolean => {
  const trimmed = String(input).trim();
  if (trimmed === '') return false;
  return /^-?\d+(?:\.\d+)?$/.test(trimmed);
};

interface SettingItemProps {
  item: [string, any];
  osType: 'ios' | 'android' | 'common';
  settingData: AppSettingResponseModel;
  setSettingData: (data: AppSettingResponseModel) => void;
}

export function SettingItem({ item, osType, settingData, setSettingData }: SettingItemProps) {
  const [isHovered, setIsHovered] = React.useState(false);

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };
  /** 특정 OS(ios, android, common)에 세팅 데이터 삭제 */
  const handleDelete = () => {
    const newData: Record<string, unknown> = { ...settingData?.content?.[osType] };
    delete newData[item[0]];
    setSettingData({
      ...settingData,
      content: {
        ...settingData?.content,
        [osType as string]: newData
      }

    });
  };

  return (
    <Space
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      style={{
        display: 'flex',
        alignItems: 'center',
        position: 'relative',
        width: 'fit-content',
        height: '50px'
      }}
    >
      /** 토글 아이템 */
      <Paragraph style={{ width: '300px', margin: 0, marginRight: '16px' }}>{item[0]}</Paragraph>
      {typeof item[1] === 'boolean' ? (
        <Switch
          defaultChecked={item[1]}
          onChange={(value) =>
            setSettingData({
              ...settingData,
              content: {
                ...settingData?.content,
                [osType as string]: {
                  ...settingData?.content?.[osType],
                  [item[0]]: value
                }
              }
            })
          }
        />
      ) : (
        /** 텍스트(숫자) 아이템 */
        <Paragraph
          editable={{
            triggerType: ['text'],
            onChange: (value) => {
              /** 숫자 타입인 경우 숫자 형식만 입력 가능하도록 */
              if (typeof item[1] === 'number' && !isNumericString(value)) {
                message.warning('숫자만 입력할 수 있어요.');
                return;
              }
              return setSettingData({
                ...settingData,
                content: {
                  ...settingData?.content,
                  [osType as string]: {
                    ...settingData?.content?.[osType],
                    [item[0]]: typeof item[1] === 'number' ? Number(value) : value
                  }
                }
              });
            },
            text: typeof item[1] === 'string' ? item[1] : JSON.stringify(item[1])
          }}
          style={{ width: 'fit-content', margin: 0 }}
        >
          {item[1]}
        </Paragraph>
      )}
      <DeleteOutlined
        onClick={handleDelete}
        style={{
          position: 'absolute',
          top: '50%',
          right: -20,
          transform: `translate(100%, -50%)`,
          opacity: isHovered ? 1 : 0
        }}
      />
    </Space>
  );
}
